import React from 'react'
import styled from 'styled-components'
import ScrollChor from 'react-scrollchor'
import Link from 'gatsby-link'
import { fonts, fontSizes, colors } from '../../theme'

const ScrollLink = styled(ScrollChor)`
  font-family: ${fonts.primary};
  font-weight: 700;
  font-size: ${fontSizes[2] + 'px'};
  transition: all 0.3s linear;
  color: #a5acb4;
  text-decoration: none;
  padding: 0.5rem;
  margin: 0 10px;

  &:hover {
    color: ${colors.primary};
  }
`

const PageLink = styled(Link)`
  font-family: ${fonts.primary};
  font-weight: 700;
  font-size: ${fontSizes[2] + 'px'};
  transition: all 0.3s linear;
  color: #a5acb4;
  text-decoration: none;
  padding: 0.5rem;
  margin: 0 10px;

  &:hover {
    color: ${colors.primary};
  }
`

const NavLink = props => (
  <span>
    {(typeof window !== 'undefined' && window.location.pathname === '/') ? (
      <ScrollLink
        to={props.to}
        children={props.children}
        animate={{offset: -60}}
      />
    ) : (
      <PageLink
        to={`/${props.to}`}
        children={props.children}
      />
    )}
  </span>
)


export default NavLink



// WEBPACK FOOTER //
// ./src/elements/Navbar/NavLink.js